export default "__VITE_ASSET__D9PA_R9o__"